import { allhomesLight } from '@domain-group/design-tokens';
export default allhomesLight;